/**
 * Input box Component
 */
export * from './input';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-inputs/src/input/index.js
// module id = 816
// module chunks = 0